export interface SortFilterOption<T extends string> {
  value: T
  label: string
  enabled: boolean
}

export interface PlannerSortFilterType {
  sortOption: SortFilterOption<server.dto.PlannerSort>
}

export const DefaultPlannerSortFilter: server.dto.PlannerSort = "date"

export const PlannerSortOptions: Array<SortFilterOption<server.dto.PlannerSort>> = [
  {
    label: RESX.DateTime.lblDate,
    value: "date",
    enabled: true
  },
  {
    label: RESX.Status.resxStatus,
    value: "phase",
    enabled: true
  }
];

export const getSortOption = (value: server.dto.PlannerSort) => {
  return PlannerSortOptions.find(s => s.value === value);
};

export const initialPlannerSortFilter: PlannerSortFilterType = {
  sortOption: getSortOption(DefaultPlannerSortFilter)
};
